// extracted by mini-css-extract-plugin
export default {"input":"ApproverInputs_input__pyNfC","input_long":"ApproverInputs_input_long__XIV8s"};